/**
 * Legacy FormApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.formApi`) keep resolving.
 *
 * The actual FormApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/form/form-api.service.ts
 */
angular.module("acme.common.service.formApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
